import {
  Component,
  Input,
  Injector,
  ViewEncapsulation,
  OnInit,
  Type, SimpleChanges, OnChanges
} from '@angular/core';
import {Video, VideosConfiguration} from '../video.model';
import {MediaPictureService} from "../../../services/media-picture.service";
import {AbstractComponent} from "../../abstract.component";
import { VideoPlayerService } from 'projects/common/services/video-player.service';
import {Module} from "../../../model/ModuleModel";
import {PictureData} from "../../picture/picture.component";
import { SliderProOptions } from '../../slider-pro/slider-pro.component';
import { MiniaturesComponent } from '../miniature/miniature.component';

@Component({
  selector: 'video-miniatures',
  template: `
      <div class="video-miniatures">
        <div class="title-container">
          <div class="picture" *ngIf="module.data.row_image?.src">
            <picture-component class="principal-image" [module]="pictureModule"
            ></picture-component>
          </div>
          <text class="row-title" *ngIf="module.pretitle || module.title || module.subtitle"
                [data]="module"></text>
        </div>

        <slider-pro
          [components]="components"
          [componentParams]="componentParams"
          [options]="sliderProOptions"
          [upaData]="upaData"
        ></slider-pro>
      </div>
  `,
  styleUrls: ['./video-miniatures.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class VideoMiniaturesComponent extends AbstractComponent implements OnInit, OnChanges {
  private static MODULE_ID: string = "VideoModule";

  @Input() override module: Module<VideosConfiguration>;

  componentParams: any[];
  components: Type<any>[];
  sliderProOptions: SliderProOptions;
  upaData: any;
  pictureModule: Module<PictureData>;

  constructor(injector: Injector,
    private mediaPictureService: MediaPictureService,
    private videoPlayerService: VideoPlayerService
    ) {
    super(injector);
  }

  ngOnInit(): void {
    this.upaData = {
      moduleId: this.module.id,
      moduleIndex: this.module.row_number,
      uniqueId: this.module.unique_id
    };

    this.pictureModule = {
      id: this.module.id,
      position: this.module.position,
      row_number: this.module.row_number, 
      data: {
        src: this.mediaPictureService.getMediaUrl(this.module.data.row_image?.src)!
      }
    }

    this.transformModelToSliderPro();
    this.initSliderProOptions();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes?.module?.firstChange && changes?.module?.currentValue != null) {
      this.ngOnInit();
    }
  }

  transformModelToSliderPro() {
    this.components = new Array(this.module.data.videos.length).fill(MiniaturesComponent);
    this.componentParams = this.module.data.videos.map((video, index) => {
      return {
        video: video,
        miniatureWidth: '56',
        clickCallback: () => this.showVideo(video, index)
      }
    });
  }

  initSliderProOptions() {
    this.sliderProOptions = {
      itemsToShow: {'DEFAULT': 3 },
      fixedWidth: {'DEFAULT': 100},
      itemsToMove: {'DEFAULT': 1 },
      dragToMove: {'DEFAULT': this.screenType != 'DESKTOP'},
      showArrows: {'DEFAULT': this.screenType == 'DESKTOP'},
      showDots: {'DEFAULT': false},
      arrowsInnerContainer: true
    };
  }

  showVideo(video: Video, i: number) {
    this.videoPlayerService.show({
      moduleId: this.module.id,
      moduleIndex: this.module.row_number,
      uniqueId: this.module.unique_id,
      positionIndex: i
    },video);
  }

  close() {
    this.videoPlayerService.close({
      moduleId: this.getModuleId(),
      uniqueId: this.module.unique_id,
      moduleIndex: this.module.row_number
    });
  }

  getModuleId() {
    return VideoMiniaturesComponent.MODULE_ID;
  }
}
